import { cn } from "@/modules/lib/utils"
import SubscriptionsEmpty from "@images/illustrations/subscriptions_2.svg"
import { BoxOfferInvitationEntity } from "@modules/boxOffer/entities/boxOfferInvitationEntity"
import { MemberOfferInvitationItem } from "@modules/members/memberOffers/components/memberOfferInvitationItem"
import { Text } from "@/components/ui/baseUi/text"

type Props = {
  boxOfferInvitations?: BoxOfferInvitationEntity[]
  emptyText?: string
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadOffersList({ boxOfferInvitations = [], emptyText, className, ...props }: Props) {
  if (boxOfferInvitations.length === 0) {
    return (
      <div className={cn("mx-6 my-1 flex w-full items-center justify-center gap-6", className)} {...props}>
        <Text fontStyle="HS" className="flex w-6/12 text-textDefault-body">
          {emptyText}
        </Text>
        <div
          className="flex h-40 w-6/12 bg-contain bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${SubscriptionsEmpty})` }}
        ></div>
      </div>
    )
  }

  return (
    <div className={cn("flex w-full flex-col gap-6", className)} {...props}>
      {boxOfferInvitations.map((item) => {
        if (item instanceof BoxOfferInvitationEntity) {
          return <MemberOfferInvitationItem item={item} key={item.id} />
        }
      })}
    </div>
  )
}
